import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Maximize, Minimize, Keyboard } from "lucide-react";

interface FullscreenNotificationProps {
  isFullscreen: boolean;
}

const FullscreenNotification: React.FC<FullscreenNotificationProps> = ({ isFullscreen }) => {
  const [showNotification, setShowNotification] = useState(false);
  
  // Visa notifikationen när fullskärmsläget ändras
  useEffect(() => {
    setShowNotification(true);
    
    // Dölj notifikationen efter 2.5 sekunder
    const timer = setTimeout(() => {
      setShowNotification(false);
    }, 2500);
    
    return () => clearTimeout(timer);
  }, [isFullscreen]);
  
  return (
    <AnimatePresence>
      {showNotification && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="fixed top-16 left-1/2 transform -translate-x-1/2 z-50 bg-gray-800/90 backdrop-blur-sm text-white rounded-lg shadow-lg border border-gray-700 px-4 py-2"
        >
          <div className="flex items-center gap-2">
            {isFullscreen ? (
              <>
                <Maximize className="h-4 w-4 text-orange-300" />
                <span>Fullskärmsläge aktiverat</span>
              </>
            ) : (
              <>
                <Minimize className="h-4 w-4 text-orange-300" />
                <span>Fullskärmsläge avslutat</span>
              </>
            )}
          </div>
          <div className="text-xs text-gray-400 mt-1 flex items-center gap-1">
            <Keyboard className="h-3 w-3" />
            {isFullscreen ? (
              <span>Tryck <kbd className="px-1 py-0.5 bg-gray-700 rounded">ESC</kbd> eller <kbd className="px-1 py-0.5 bg-gray-700 rounded">F11</kbd> för att avsluta</span>
            ) : (
              <span>Tryck <kbd className="px-1 py-0.5 bg-gray-700 rounded">F11</kbd> för genväg till fullskärm</span>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FullscreenNotification;